export enum PasswordResetStatus {
  FAILED = 'failed'
}
